import type { AppState, Schedule } from "./types";

const b64url = (b: Uint8Array) => btoa(String.fromCharCode(...b)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
const unb64url = (s: string) => Uint8Array.from(atob(s.replace(/-/g, "+").replace(/_/g, "/")), (c) => c.charCodeAt(0));

async function pipe(data: Uint8Array, stream: CompressionStream | DecompressionStream): Promise<Uint8Array> {
  const src = new ReadableStream<Uint8Array>({ start(c) { c.enqueue(data); c.close(); } });
  const out = new Response(src.pipeThrough(stream as unknown as TransformStream<Uint8Array, Uint8Array>));
  return new Uint8Array(await out.arrayBuffer());
}

/** Encode one schedule for a URL hash: "1." + base64url(deflate-raw(JSON)). */
export async function encodeSchedule(s: Schedule): Promise<string> {
  const json = new TextEncoder().encode(JSON.stringify(s));
  return "1." + b64url(await pipe(json, new CompressionStream("deflate-raw")));
}

export async function decodeSchedule(token: string): Promise<Schedule> {
  const [v, body] = token.split(".", 2);
  if (v !== "1" || !body) throw new Error("Unsupported share link version");
  const json = new TextDecoder().decode(await pipe(unb64url(body), new DecompressionStream("deflate-raw")));
  const s = JSON.parse(json) as Schedule;
  if (!Array.isArray(s.picks)) throw new Error("Invalid schedule");
  return { name: s.name || "Shared", term: s.term || "winter", picks: s.picks, edits: s.edits || {}, custom: s.custom || [] };
}

export const emptyState = (): AppState => ({ v: 1, active: 0, schedules: [{ name: "Moj raspored", term: "winter", picks: [], edits: {}, custom: [] }] });
